import { render, staticRenderFns } from "./LoginV2.vue?vue&type=template&id=7a1a48d8&scoped=true"
import script from "./LoginV2.vue?vue&type=script&lang=js"
export * from "./LoginV2.vue?vue&type=script&lang=js"
import style0 from "./LoginV2.vue?vue&type=style&index=0&id=7a1a48d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1a48d8",
  null
  
)

export default component.exports